import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Route, Routes, useLocation } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import QuestionsPage from './exam/QuestionsPage';  // Seu componente de página inicial
import SuccessPage from './exam/SuccessPage';  // A página para onde você quer redirecionar após o envio com sucesso
import Login from './auth/Login';
import MyMocks from './dashboard/MyMocks';
import CourseSelection from './dashboard/CourseSelection/CourseSelection';
import Profile from './dashboard/Profile';
import Plans from './dashboard/Plans';
import RegisterPage from './auth/Register';
import FreeQuestions from './practice/FreeQuestions/FreeQuestions';
import AdminPage from './admin/AdminPage';
import ResetPassword from './auth/ResetPassword/ResetPassword';
import StudyPlan from './study/StudyPlan/StudyPlan';
import StudyLog from './study/StudyLog/StudyLog';
import SubjectSelection from './study/SubjectSelection/SubjectSelection';
import TrialQuestions from './practice/TrialQuestions/TrialQuestions';
import TrialResults from './practice/TrialQuestions/TrialResults';
import WrongAnswers from './practice/WrongAnswers/WrongAnswers';
import PhysicalTraining from './practice/PhysicalTraining/PhysicalTraining';
import { ThemeProvider } from './contexts/ThemeContext';
import { CourseProvider } from './contexts/CourseContext';
import ThemeToggle from './components/ThemeToggle';
import Splash from './Splash';

// MyMocks renderiza seu próprio ThemeToggle (junto com os botões de
// funcionalidades e logout, lado a lado), então o global some nessa rota
// para não duplicar o ícone.
const ROUTES_WITH_OWN_THEME_TOGGLE = ['/simulados'];

// Trocar de curso só é permitido na tela de Simulados. O header padrão
// (components/DashboardTopbar.js) inclui o CourseSwitcher em todas as telas
// que o usam, mas desabilitado por padrão — só MyMocks.js passa
// allowCourseChange para liberar a troca.
function AppShell({ isOnline }) {
  const location = useLocation();
  const hideGlobalThemeToggle = ROUTES_WITH_OWN_THEME_TOGGLE.includes(location.pathname);

  return (
    <>
      {!hideGlobalThemeToggle && <ThemeToggle />}
      {!isOnline && (
        <div style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          zIndex: 9999,
          background: '#fef2f2',
          color: '#991b1b',
          padding: '10px 14px',
          textAlign: 'center',
          fontSize: '14px',
          borderBottom: '1px solid #fecaca'
        }}>
          Sem internet no momento. Algumas funções podem ficar indisponíveis.
        </div>
      )}
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/simulados" element={<MyMocks />} />
        <Route path="/escolher-concurso" element={<CourseSelection />} />
        <Route path="/perfil" element={<Profile />} />
        <Route path="/planos" element={<Plans />} />
        <Route path="/questoes" element={<QuestionsPage />} />
        <Route path="/success" element={<SuccessPage />} />
        <Route path="/cadastro" element={<RegisterPage />} />
        <Route path="/questao" element={<FreeQuestions />} />
        <Route path="/adm" element={<AdminPage />} />
        <Route path="/redefinirSenha" element={<ResetPassword />} />
        <Route path="/plano-de-estudos" element={<StudyPlan />} />
        <Route path="/diario-de-estudos" element={<StudyLog />} />
        <Route path="/selecionar-materias" element={<SubjectSelection />} />
        <Route path="/questao-treino" element={<TrialQuestions />} />
        <Route path="/questao-treino/resultado" element={<TrialResults />} />
        <Route path="/meus-erros" element={<WrongAnswers />} />
        <Route path="/treino-fisico" element={<PhysicalTraining />} />
      </Routes>
    </>
  );
}

function App() {
  const [isOnline, setIsOnline] = useState(navigator.onLine);
  const [showSplash, setShowSplash] = useState(true);

  useEffect(() => {
    const handleOnline = () => setIsOnline(true);
    const handleOffline = () => setIsOnline(false);

    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);

    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, []);

  return (
    <>
      {showSplash && <Splash onFinish={() => setShowSplash(false)} />}
      <HelmetProvider>
      <ThemeProvider>
      <CourseProvider>
      <Router>
        <AppShell isOnline={isOnline} />
      </Router>
      </CourseProvider>
      </ThemeProvider>
      </HelmetProvider>
    </>
  );
}

export default App;